import React, { Component } from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";

interface IMainSettingPanelComponent {
    data: {}
}
export const mainSettingPanelComponent: IMainSettingPanelComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "name": "backgroundGraphicSettingPanel",
                        "type": "Graphic",
                        "shape": "rectangle",
                        // "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "alpha": 1,
                        "color": "0x191919",
                        "x": 0,
                        "y": 0,
                        "width": 1920,
                        "height": 1080,

                    },
                    {
                        "name": "topBar",
                        "image": "land_page_top_bar.png",
                        "type": objectTypes.Sprite,
                        // "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "x": 0,
                        "y": 0,
                        "width": 1717,
                        "height": 193,
                    },

                    {
                        "name": "sideBar",
                        "image": "land_side_bar.png",
                        "type": objectTypes.Sprite,
                        // "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "x": 1710,
                        "y": 0,
                        "width": 210,
                        "height": 1080,
                    },







                    {
                        "id": "buttonscontainer",
                        "name": "buttonscontainer",
                        "type": "Container",
                        "class": "",
                        "x": 1768,
                        "y": 0,
                        // "layout": true,
                        "uimode": "mobile",
                        "filterTypes": [],
                        child: [
                            {
                                "id": "Button_M1",
                                "name": "btn_guide_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 202,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'i_setting_icon_up.png',
                                    out: 'i_setting_icon_up.png',
                                    down: 'i_setting_icon_up.png',
                                    disable: 'i_setting_icon_up.png',
                                    enable: 'i_setting_icon_up.png',
                                    hover: 'i_setting_icon_up.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "Button_M5",
                                "name": "btn_guide_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 202,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'i_setting_icon_over.png',
                                    out: 'i_setting_icon_over.png',
                                    down: 'i_setting_icon_over.png',
                                    disable: 'i_setting_icon_over.png',
                                    enable: 'i_setting_icon_over.png',
                                    hover: 'i_setting_icon_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "text_1",
                                "name": "btn_guide_text",
                                "type": "Text",
                                //  "layout": true,
                                "uimode": "mobile",
                                "x": -902,
                                "y": 97,
                                "text": "menu-title_game-guide_main",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },



                            {
                                "id": "Button_M2",
                                "name": "btn_paytable_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                //  "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 430,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'autoplay_setting_icon_up.png',
                                    out: 'autoplay_setting_icon_up.png',
                                    down: 'autoplay_setting_icon_up.png',
                                    disable: 'autoplay_setting_icon_up.png',
                                    enable: 'autoplay_setting_icon_up.png',
                                    hover: 'autoplay_setting_icon_up.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "Button_M6",
                                "name": "btn_paytable_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                //"layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 430,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'autoplay_setting_icon_over.png',
                                    out: 'autoplay_setting_icon_over.png',
                                    down: 'autoplay_setting_icon_over.png',
                                    disable: 'autoplay_setting_icon_over.png',
                                    enable: 'autoplay_setting_icon_over.png',
                                    hover: 'autoplay_setting_icon_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "text_2",
                                "name": "btn_paytable_text",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -902,
                                "y": 97,
                                "text": "game-guide_control_heading_paytable",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },





                            {
                                "id": "Button_M3",
                                "name": "btn_history_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 658,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {

                                    up: 'history_setting_icon_up.png',
                                    out: 'history_setting_icon_up.png',
                                    down: 'history_setting_icon_up.png',
                                    disable: 'history_setting_icon_up.png',
                                    enable: 'history_setting_icon_up.png',
                                    hover: 'history_setting_icon_up.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "Button_M7",
                                "name": "btn_history_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                //"layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 658,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {


                                    up: 'history_setting_icon_over.png',
                                    out: 'history_setting_icon_over.png',
                                    down: 'history_setting_icon_over.png',
                                    disable: 'history_setting_icon_over.png',
                                    enable: 'history_setting_icon_over.png',
                                    hover: 'history_setting_icon_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "text_3",
                                "name": "btn_history_text",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -902,
                                "y": 97,
                                "text": "game-guide_control_heading_bet-history",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },





                            {
                                "id": "Button_M4",
                                "name": "btn_setting_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 886,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'land_setting_icon_up.png',
                                    out: 'land_setting_icon_up.png',
                                    down: 'land_setting_icon_up.png',
                                    disable: 'land_setting_icon_up.png',
                                    enable: 'land_setting_icon_up.png',
                                    hover: 'land_setting_icon_up.png'



                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "Button_M8",
                                "name": "btn_setting_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 886,
                                "height": 63,
                                "width": 59,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'land_setting_icon_over.png',
                                    out: 'land_setting_icon_over.png',
                                    down: 'land_setting_icon_over.png',
                                    disable: 'land_setting_icon_over.png',
                                    enable: 'land_setting_icon_over.png',
                                    hover: 'land_setting_icon_over.png'

                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "text_4",
                                "name": "btn_setting_text1_white",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -800,
                                "y": 97,
                                "text": "menu-title_settings_general",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },




                            {
                                "id": "text_6",
                                "name": "btn_setting_text1_yellow",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -800,
                                "y": 97,
                                "text": "menu-title_settings_general",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#ffc107'],
                                    align: "center",
                                },
                                "parentLayer": "specialAnimationLayer",
                            },






                            // {
                            //     "name": "gameSettingsBtnMobile",
                            //     "type": "Graphic",
                            //     "shape": "rectangle",
                            //     "layout": true,
                            //     "uimode": "mobile",
                            //     "interactive": true,
                            //     "buttonMode": true,
                            //     "visible": true,
                            //     "alpha": 0.01,
                            //     "color": "0xffffff",
                            //     "x": -1419,
                            //     "y": 53,
                            //     "width": 300,
                            //     "height": 100,

                            // },





                        ],


                    },


                    {
                        "id": "Button_M9",
                        "name": "settingPanelCloseButton",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        //  "layout": true,
                        "uimode": "mobile",
                        "x": 64,
                        "y": 94,
                        "height": 36,
                        "width": 36,
                        "text": "",
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'settings_closed_icon.png',
                            out: 'settings_closed_icon.png',
                            down: 'settings_closed_icon.png',
                            disable: 'settings_closed_icon.png',
                            enable: 'settings_closed_icon.png',
                            hover: 'settings_closed_icon.png'

                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },




                    {
                        "id": "Button_M10",
                        "name": "homeButton",
                        "image": "homeButton",
                        "type": "Image",
                        // "layout": true,
                        "buttonMode": true,
                        "interactive": true,
                        "uimode": "mobile",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "anchor": [0.5, 0.5],
                        "visible": false,
                        "width": 100,
                        "height": 92,
                        "x": 1600,
                        "y": 100
                    },

                    // {
                    //     "name": "yellowLine",
                    //     "image": "land_header_text_highlight_line.png",
                    //     "type": objectTypes.Sprite,
                    //     "layout": true,
                    //     "uimode": "mobile",
                    //     "visible": true,
                    //     "x": 785,
                    //     "y": 177,
                    //     "width": 372,
                    //     "height": 3,
                    // },
                    {
                        "id": "GameGuideContainer",
                        "name": "GameGuideContainer",
                        "type": "Tag",
                        "class": "",
                        "visible": true,
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },



                    {
                        "id": "GameGeneralComponent",
                        "name": "GameGeneralComponent",
                        "type": "Tag",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },


                    {
                        "id": "GameAutoplayComponent",
                        "name": "GameAutoplayComponent",
                        "type": "Tag",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },

                    {
                        "id": "MobilePaytable",
                        "name": "MobilePaytable",
                        "type": "Tag",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },
                    {
                        "name": "ui_base_mobileMenu",
                        "image": "ui_base.png",
                        "type": objectTypes.Sprite,
                        //   "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "width": 1920,
                        "height": 84,
                        "x": 0,
                        "y": 996,
                    },
                    {
                        id: "gameName_label_bottom",
                        "name": "gameName_label_bottom",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "messageInLoop": true,
                        //   "layout": true,
                        "uimode": "mobile",
                        "x": 0,
                        "y": 0,
                        "width": 0,
                        "height": 0,
                        "filterTypes": [],
                        child: [

                            {
                                "id": "gameName_label_bottom1",
                                "name": "gameName_label_bottom1",
                                "type": "Text",
                                "x": 1760,
                                "y": 1063,
                                "width": 500,
                                "visible": true,
                                "text": "INCA IDOLS",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-SemiBold',
                                    fontSize: 20,
                                    fontStyle: 'normal',
                                    fill: ['#999999'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },

                            {
                                "id": "game_clock",
                                "name": "game_clock",
                                "type": "Text",
                                "x": 74,
                                "y": 1063,
                                "width": 300,
                                "visible": true,
                                "text": "10.41",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-SemiBold',
                                    fontSize: 20,
                                    fontStyle: 'normal',
                                    fill: ['#999999'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            /*   {
                                  "name": "brand_icon",
                                  "image": "brand_icon.png",
                                  "type": "Image",
                                  "class": "",
                                  "layout": true,
                                  "uimode": "mobile",
                                  "visible": true,
                                  "width": 24,
                                  "height": 25,
                                  "x": 1885,
                                  "y": 1049
                              }, */


                        ]

                    },


                ]
            },

        ],
    }


};

export const MainSettingPanelComponentConfigurationContext = React.createContext(
    {}
);